var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsSpiral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 612,
    viewBox: "0 0 263 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M511.387 609.806C511.387 609.806 437.553 587.507 428.559 548.226C422.974 523.833 418.087 499.632 439.115 486.073C451.975 477.78 467.416 473.86 476.491 486.187C485.405 498.296 478.749 511.612 469.353 523.345C438.274 562.155 372.826 512.196 344.159 480.785C297.281 429.418 375.141 316.495 297.299 264.398C262.157 240.879 199.116 245.171 185.614 285.226C181.546 297.296 180.526 305.285 190.105 313.687C200.972 323.218 213.167 316.94 224.019 307.399C254.044 281.003 226.975 231.435 196.125 205.985C140.552 160.141 60.2574 211.238 19.2289 152.838C-17.2599 100.901 18.2177 2.00002 18.2177 2.00002",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsSpiral);
export default __webpack_public_path__ + "static/media/contactUsSpiral.9330571462c75100423a46877c40ad13.svg";
export { ForwardRef as ReactComponent };